<template>
  <Nav-bar :has_back="true" :has_right="false" title="充电中"></Nav-bar>
  <div class="container">
    <div class="gif-container">
      <img src="@/images/charging.gif" class="gif-icon" />
      <div class="station_info_v display_column">
        <span class="t-f16-c1a">{{ state.ordersStation.name }}</span>
        <span class="t-f16-c1a m-t-10">{{
          state.ordersCharge.serial_number
        }}</span>
      </div>
    </div>
    <div class="info-container">
      <div class="t-f14-c66">剩余充电时长</div>
      <div class="t-f22-c1a font-bold m-t-10">
        {{ $filters.toHourMinute(state.chargingData.remaining_time) || "-" }}
      </div>
      <div class="block_container">
        <div class="block_item">
          <span class="t-f13-c66">实时功率</span>
          <span class="t-f16-c1a font-bold"
            >{{ $filters.toFixed(state.chargingData.power) || "-" }} kW</span
          >
        </div>
        <div class="block_item">
          <span class="t-f13-c66">实时电流</span>
          <span class="t-f16-c1a font-bold"
            >{{ $filters.toFixed(state.chargingData.current) || "-" }}A</span
          >
        </div>
        <div class="block_item">
          <span class="t-f13-c66">实时电压</span>
          <span class="t-f16-c1a font-bold"
            >{{ $filters.toFixed(state.chargingData.voltage) || "-" }}V</span
          >
        </div>
        <div class="block_item">
          <span class="t-f13-c66">已充电量</span>
          <span class="t-f16-c1a font-bold"
            >{{
              $filters.toFixed(state.chargingData.charged_power) || "-"
            }}度</span
          >
        </div>
        <div class="block_item">
          <span class="t-f13-c66">已充时间</span>
          <span class="t-f16-c1a font-bold"
            >{{ state.chargingData.charged_time_in_seconds || "-" }}分钟</span
          >
        </div>
        <div class="block_item">
          <span class="t-f13-c66">充电金额</span>
          <span class="t-f16-c1a font-bold"
            >{{ $filters.toFixed(state.chargingData.amount) || "-" }}元</span
          >
        </div>
      </div>
      <div class="m-20">
        <van-button
          type="primary"
          size="normal"
          class="main-btn"
          @click="stopEle"
          >结束充电并结算</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../../components/NavBar.vue";
import request from "@/api/request";
import { useRouter } from "vue-router";
import { reactive } from "vue";
import { Dialog, Toast } from "vant";
import config from "@/api/config";
let state;
let orderId;
let router;
let stopChargeInterval;
let stopChargeTimeOutInterval;

let lockReconnect = false; //避免重复连接
let ws;
let tt;
let reconnectCount = 0; //重连次数计数器
const maxReconnectCount = 5; //最大重连次数
export default {
  components: {
    NavBar: NavBar,
  },
  unmounted() {
    clearDataTools();
  },
  setup() {
    state = reactive({
      chargingData: {},
      ordersStation: {},
      ordersCharge: {},
    });
    router = useRouter();
    orderId = useRouter().currentRoute.value.params.id;
    checkOrderDetails(orderId);
    connectWebSoket(orderId);
    return { connectWebSoket, orderId, state, stopEle, checkOrderDetails };
  },
};
function checkOrderDetails(id) {
  request.getOrdersDetails(id).then((res) => {
    state.ordersStation = res.data.charge_station;
    state.ordersCharge = res.data.charger;
  });
}
function stopEle() {
  Dialog.confirm({
    title: "确定结束订单吗？",
  })
    .then(() => {
      Toast.loading({
        message: "正在结算订单...",
        duration: 0,
      });
      apiStopRequest();
    })
    .catch(() => {});
}

function connectWebSoket(id) {
  let serverUrl = config.baseUrl.web_socket;

  if (serverUrl.indexOf("-webapp") != -1) {
    serverUrl = serverUrl.replace("-webapp", "-ws");
    serverUrl = serverUrl.replace("https", "wss");
  }
  let wsUrl = serverUrl + "?order_id=" + id;
  Toast.loading({
    message: "服务器正在建立连接...",
    duration: 0,
  });

  // 打开一个 web socket
  try {
    ws = new WebSocket(wsUrl);
    init();
  } catch (e) {
    reconnect(wsUrl);
  }

  function init() {
    ws.onclose = function () {};
    ws.onerror = function () {
      if (router.currentRoute.value.path.includes("Charging")) {
        reconnect(wsUrl);
      }
    };
    ws.onopen = function () {
      // ws.send("发送数据")
      Toast.clear();
      reconnectCount = 0; // 连接成功时重置重连计数器
    };
    let hasNavigated = false; // 防止重复跳转

    ws.onmessage = function (event) {
      try {
        const chargingData = JSON.parse(event.data);
        const { status, occupancy_status, data } = chargingData;
        console.log("socket-------", chargingData);
        // 更新状态数据
        state.chargingData = data;

        if (hasNavigated) return;

        if (status === "complete" || status === "stop") {
          if (occupancy_status !== "skip") {
            hasNavigated = true;
            router.replace(`/user/orders_details/${id}`);
          } else {
            toAccount(orderId);
          }
        } else if (status === "unpaid" || occupancy_status === "calculating") {
          hasNavigated = true;
          router.replace(`/user/orders_details/${id}`);
        }
      } catch (e) {
        console.error("WebSocket 数据解析错误:", e);
      }
    };
  }
  function reconnect() {
    if (lockReconnect) {
      return;
    }

    // 检查重连次数
    if (reconnectCount >= maxReconnectCount) {
      Dialog.alert({
        title: "连接失败",
        message: "服务器连接失败，请稍后重试",
      }).then(() => {
        router.go(-1); // 退出页面
      });
      return;
    }

    lockReconnect = true;
    reconnectCount++; // 增加重连次数
    //没连接上会一直重连，设置延迟避免请求过多
    tt && clearTimeout(tt);
    tt = setTimeout(function () {
      lockReconnect = false;
      connectWebSoket(orderId);
    }, 5000);
  }
}
function clearDataTools() {
  Toast.clear();
  // 安全关闭WebSocket连接
  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.close();
  }
  // 清除重连定时器
  if (tt) {
    clearTimeout(tt);
    tt = null;
  }
  // 重置重连计数器
  reconnectCount = 0;
  // 关掉计时器
  if (stopChargeInterval) {
    clearInterval(stopChargeInterval);
    stopChargeInterval = null;
  }
  if (stopChargeTimeOutInterval) {
    clearTimeout(stopChargeTimeOutInterval);
    stopChargeTimeOutInterval = null;
  }
}
function toAccount(id) {
  clearDataTools();
  router.replace(`/station/Account/${id}`);
}
function checkOrdersStatus(id) {
  request
    .getOrdersDetails(id)
    .then((res) => {
      if (res.data.status == "paid") {
        //去结算页面
        toAccount(orderId);
      }
    })
    .catch((error) => {
      console.error("检查订单状态失败:", error);
      // 网络错误时清理定时器，避免持续请求
      if (stopChargeInterval) {
        clearInterval(stopChargeInterval);
        stopChargeInterval = null;
      }
    });
}
function apiStopRequest() {
  request.putStopCharge(orderId).then((res) => {
    if (res.data.status == "complete") {
      toAccount(res.data.id);
    } else {
      stopChargeTimeOutInterval = setTimeout(function () {
        if (stopChargeInterval != null) {
          Toast.fail("结算异常!");
          //去结算页面
          toAccount(orderId);
        }
      }, 30000);
      stopChargeInterval = setInterval(function () {
        checkOrdersStatus(orderId);
      }, 5000);
    }
  });
}
</script>

<style scoped>
body {
  background: #fff !important;
}
.container {
  background: #fff;
}
.station_info_v {
  position: absolute;
  top: 70px;
  left: 50%;
  text-align: center;
  transform: translateX(-50%);
}
.gif-container {
  position: relative;
}
.gif-icon {
  height: 297px;
  width: 100%;
}
.info-container {
  text-align: center;
}

.block_container {
  display: flex;
  flex-wrap: wrap;
  margin: 30px 15px;
}
.block_item {
  width: calc(calc(100% / 3) - 10px);
  margin: 5px;
  text-align: center;
  align-items: center;
  display: inherit;
  padding: 10px 0px;
  border-radius: 10px;
  flex-direction: column;
  background: #f6f6f6;
  box-sizing: border-box;
}
</style>
